/* projects/fitnessforservice/src/app/type-a-component/horizontalvessel/horizontalvessel.component.css */
/*# sourceMappingURL=horizontalvessel.component.css.map */
